import React, { PureComponent, useEffect, useState } from "react";
import { AxiosCustomPost } from "../components/axios/AxiosCustom";
import Config from "../components/axios/Config";
import Cookie from "js-cookie";
import AppRoutePath from "../router/AppRoutePath";
import SwalToast from "../components/helpers/SwalToast";
import IsEmpty from "../components/helpers/IsEmpty";
import { Modal, Button, Input } from "antd";
import ErrorDiv from "../components/helpers/ErrorDiv";
import httpclient from "../components/httpclient";
import Notifications from "../components/template/notification/Notification";

function Login(props) {
  const [email, setEmail] = useState();
  const [emailReset, setEmailReset] = useState();
  const [errorEmailReset, setErrorEmailReset] = useState();
  const [password, setPassword] = useState();
  const [modalResetPassword, setModalResetPassword] = useState(false);
  const [modalResetSent, setModalResetSent] = useState(false);
  const [resubmit, setResubmit] = useState(false);

  const [counter, setCounter] = React.useState(60);
  const [statusCounter, setStatusCounter] = React.useState("");

  useEffect(() => {
    if (
      !IsEmpty(Cookie.get("access_token")) &&
      !IsEmpty(Cookie.get("refresh_token"))
    ) {
      props.history.push(AppRoutePath.DASHBOARD);
    }
  }, []);

  useEffect(() => {
    let counterId;
    if ((statusCounter === "start") & (counter !== 0)) {
      counterId = setTimeout(() => setCounter(counter - 1), 1000);
    }

    return () => {
      clearTimeout(counterId);
    };
  }, [counter, statusCounter]);

  const changeValue = (event) => {
    if (event.target.name === "email") {
      setEmail(event.target.value);
    } else if (event.target.name === "password") {
      setPassword(event.target.value);
    } else if (event.target.name === "email-reset") {
      setEmailReset(event.target.value);
    }
  };

  const submit = async (event) => {
    let token = await Cookie.get("firebase_token");
    event.preventDefault();
    AxiosCustomPost(
      `${process.env.REACT_APP_BASE_API_URL}auth/login`,
      {
        email: email,
        password: password,
      },
      Config(),
      (response) => {
        Cookie.set("access_token", response.data.data.access_token);
        Cookie.set("refresh_token", response.data.data.refresh_token);
        if (token) {
          handlePostToken(token);
        }
        props.history.push(AppRoutePath.DASHBOARD);
      },
      (error) => {
        console.log(error);
        SwalToast.fire({
          icon: "error",
          title: "Unauthorized!",
        });
      }
    );
  };

  const handlePostToken = (token) => {
    let data = {
      token,
      device: "web",
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}users/ActivateUserPushNotif`;
    httpclient
      .POST(url, data)
      .then((response) => {
        // Cookie.set("firebase_token", token);
        // console.log("handlePostToken", response.data.data);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      });
  };

  const validateReset = () => {
    let validate = true;
    setErrorEmailReset();

    if (IsEmpty(emailReset)) {
      validate = false;
      setErrorEmailReset("Email harus diisi");
    }
    return validate;
  };

  const submitReset = (event) => {
    if (!validateReset()) return;
    event.preventDefault();

    AxiosCustomPost(
      `${process.env.REACT_APP_BASE_API_URL}auth/reset-password`,
      {
        email: emailReset,
      },
      Config(),
      (response) => {
        console.log(response.data.data);
        setModalResetPassword(false);
        setModalResetSent(true);
        setStatusCounter("start");
      },
      (error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const reSubmitReset = (event) => {
    if (!validateReset()) return;

    event.preventDefault();
    AxiosCustomPost(
      `${process.env.REACT_APP_BASE_API_URL}auth/reset-password`,
      {
        email: emailReset,
      },
      Config(),
      (response) => {
        setResubmit(true);
        setModalResetPassword(false);
        setModalResetSent(true);
      },
      (error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleCloseModal = () => {
    setModalResetPassword(false);
    setModalResetSent(false);
  };

  return (
    <div
      className=""
      style={{
        // width: 550,
        height: "100vh",
        backgroundImage: `url(${process.env.REACT_APP_PUBLIC_URL}images/background.jpg)`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Notifications />
      <div className="ohana-container-login d-flex justify-content-center align-items-center">
        <form
          onSubmit={submit}
          className="bg-white shadow-graph mx-auto p-3"
          style={{ width: 500, borderRadius: 12, height: 580 }}
        >
          <div className="d-flex flex-column align-items-center">
            <div className="d-flex align-items-center pt-5">
              <img
                src={`${process.env.REACT_APP_PUBLIC_URL}images/degadai-logo.svg`}
                style={{ width: 304, height: 159, left: 76.5, top: 36 }}
              />
            </div>

            <div className="px-1">
              <div className="pt-3 d-flex align-self-start">
                <h4 className="color-303030 font-weight-bold">Login</h4>
              </div>

              <div className="form-group mt-3" style={{ height: 36 }}>
                <label htmlFor="email" className="color-A6A6A6">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control border-radius-8-px"
                  id="email"
                  name="email"
                  required
                  value={email}
                  onChange={changeValue}
                />
              </div>
              <div
                className="form-group mt-5"
                style={{ width: 367, height: 36 }}
              >
                <label
                  htmlFor="virtual-sdb-desktop-password"
                  className="color-A6A6A6"
                >
                  Password
                </label>
                <input
                  type="password"
                  className="form-control border-radius-8-px"
                  id="virtual-sdb-desktop-password"
                  name="password"
                  required
                  value={password}
                  onChange={changeValue}
                />
              </div>

              {/* <a
                onClick={() => setModalResetPassword(true)}
                className="d-flex justify-content-end color-2C465C mt-5"
              >
                Lupa Password
              </a> */}
              <div
                className="form-group mt-5"
                style={{ width: 367, height: 36 }}
              >
                <button
                  style={{ height: 42 }}
                  type="submit"
                  className="form-control btn text-white bgc-2C465C border-radius-8-px"
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <Modal
        // className="modal-edit"
        centered
        title={`Reset Password`}
        visible={modalResetPassword}
        // onOk={handleSubmit}
        onCancel={handleCloseModal}
        footer={[
          <Button
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            onClick={submitReset}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Kirim
          </Button>,
        ]}
      >
        <div className="my-3">
          <label htmlFor="email" className="color-A6A6A6">
            Email
          </label>
          <input
            type="email"
            className="form-control border-radius-8-px"
            id="email"
            name="email-reset"
            required
            value={emailReset}
            onChange={changeValue}
          />
          <ErrorDiv error={errorEmailReset} />
        </div>
      </Modal>

      <Modal
        centered
        title={`Cek Email Anda`}
        visible={modalResetSent}
        // onOk={handleSubmit}
        onCancel={handleCloseModal}
        footer={[
          <Button
            type="submit"
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 48,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Tutup
          </Button>,
        ]}
      >
        <div className="my-3">
          <p>
            Link untuk mengubah password sudah dikirim ke {emailReset}. Silahkan
            cek di folder spam jika tidak tersedia.
          </p>
          {!resubmit && (
            <p>
              Tidak terima email?{" "}
              <a
                disabled={counter !== 0}
                onClick={counter === 0 ? reSubmitReset : null}
                className="font-weight-bold"
                style={{ color: counter !== 0 ? "#DCDCDC" : "#2C465C" }}
              >
                Kirim ulang
              </a>
              {counter !== 0 && (
                <span className="ml-1 color-DCDCDC">({counter})</span>
              )}
            </p>
          )}
        </div>
      </Modal>
    </div>
  );
}

export default Login;
